/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_Chip_3Inputs */

const en_services_flow_chip_3 = /** @type {(inputs: Services_Flow_Chip_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM`)
};

const lv_services_flow_chip_3 = /** @type {(inputs: Services_Flow_Chip_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM`)
};

/**
* | output |
* | --- |
* | "CRM" |
*
* @param {Services_Flow_Chip_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_chip_3 = /** @type {((inputs?: Services_Flow_Chip_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_Chip_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_chip_3(inputs)
	return en_services_flow_chip_3(inputs)
});